import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import StatsSection from './components/StatsSection';
import TemplatesSection from './components/TemplatesSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '免费在线成网站',
    url: 'https://zonemaker.github.io/',
    description: '零成本快速建站平台，无需编程，一键生成专业网站。支持企业官网、个人博客、电商页面等多种类型。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://zonemaker.github.io/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '免费在线成网站',
    url: 'https://zonemaker.github.io/',
    description: '中国领先的免费在线建站平台，提供零成本一键建站服务。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'support@mianfeijianzhan.com',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />

      <main>
        <Navbar />
        <HeroSection />
        <FeaturesSection />
        <StatsSection />
        <TemplatesSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}